/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { DropdownWrapper, DropdownToggle, DropdownMenu, DropdownItem } from 'components/dropdown';
import { connect, useDispatch } from 'react-redux';
import { useLogoutMutation } from 'api/authAPI';
import { logoutReducer } from 'features/auth/authSlice';
import PropTypes from 'prop-types';
import userImage from 'assets/images/user.png';
import Breadcrumb from 'components/breadcrumb';
import NotifyItem from 'components/notifyItem';
import Button from 'components/button';
import { removeState, saveState, loadState, checkPermission } from 'utils';
import { useChangeUserCompanyMutation } from 'api/users/company';
import ArrowDown from 'assets/icons/down';
import ArrowUp from 'assets/icons/up';
import { getUnreadNotifications, markNotificationAsRead } from 'api/notifications';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LayoutConteact } from '../context/appLayout';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import moment from 'moment';
import { setLoading } from 'features/loading';
// import cayeshLogo from 'assets/images/salasel-logo.svg';
import cayeshLogo from 'assets/images/cayesh-logo.png';

// import bankLogo from 'EFG_Logo.png';

const Header = ({ companies, permissions, user }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [logout] = useLogoutMutation();
	const dispatch = useDispatch();
	const STORAGE_KEY = 'cayesh_user_loggged';
	const storedUser = loadState(STORAGE_KEY);
	const { category } = storedUser.user;

	const [selectedCompany, setSelectedCompany] = useState(storedUser?.currentCompany);
	const [selectedLang, setSelectedLang] = useState({
		name: t('English'),
		key: 'EN'
	});
	const languages = [
		{ name: 'English', key: 'en' },
		{ name: 'عربى', key: 'ar' }
	];
	const [isCompanyOpen, setCompanyOpen] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const [companiesList, setCompaniesList] = useState([]);
	const [permissionsList, setPermissionsList] = useState(permissions);
	const [activeUser, setActiveUser] = useState(user);
	const [reload, setReload] = useState(false);
	const [changeUserCompany] = useChangeUserCompanyMutation();
	let listOfActiveCompanies = [];

	const { setIsSidbarCollapsed, isSidbarCollapsed } = useContext(LayoutConteact);
	useEffect(() => {
		listOfActiveCompanies = storedUser?.companies?.filter(company => !company.deactivated_at);
	}, [companies]);

	useEffect(() => {
		setPermissionsList(permissions);
	}, [permissions]);

	useEffect(() => {
		setActiveUser(user);
	}, [user]);

	useEffect(() => {
		setCompaniesList(storedUser?.companies);
	}, []);

	const getNotifications = async () => {
		const response = await getUnreadNotifications();
		const { loginTime } = loadState('cayesh_user_loggged');
		const start = moment(loginTime);
		const now = moment();
		const isExpired = now.diff(start, 'hours') >= 8;
		if (isExpired) {
			dispatch(setLoading(true));
			logout()
				.unwrap()
				.then(res => {
					if (res.message) {
						dispatch(logoutReducer());
					}
				})
				.catch(err => {
					if (err.status === 403) {
						dispatch(logoutReducer());
					}
				});
		}
		setNotifications(response.data.data);
	};

	const handleOnNotificationClick = async id => {
		await markNotificationAsRead(id);
		getNotifications();
	};

	useEffect(() => {
		if (category === 'company') {
			changeUserCompany({ company_id: selectedCompany?.id })
				.unwrap()
				.then(res => {
					saveState(
						{
							...loadState(STORAGE_KEY),
							user: res.user,
							currentCompany: res.current_company,
							companies: res.companies
						},
						STORAGE_KEY
					);
					if (reload) {
						navigate(0);
						setReload(false);
					}
				});
		}
		getNotifications();
	}, [selectedCompany]);

	const toggleDropdown = () => setCompanyOpen(prevState => !prevState);

	return (
		<header className={`cayesh--navbar ${isSidbarCollapsed ? 'nav--collapse' : ''}`}>
			<div className='d-flex justify-content-start align-items-center'>
				<button
					className={'btn btn-link pb-3 pt-3 btn-collapse'}
					onClick={() => {
						setIsSidbarCollapsed(!isSidbarCollapsed);
					}}
				>
					{isSidbarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
				</button>
				<img src={cayeshLogo} alt='' className={`navbar--img ${isSidbarCollapsed ? 'nav--collapse' : ''}`} />
				{/* <Breadcrumb /> */}
			</div>

			<div className='d-flex justify-content-end align-items-center'>
				{/* companies */}
				{activeUser?.category === 'company' && (
					<DropdownWrapper className='company-dropdown'>
						<DropdownToggle
							id='campany'
							onClick={listOfActiveCompanies.length > 1 ? toggleDropdown : null}
							onBlur={toggleDropdown}
						>
							<div className='company-container d-flex flex-row justify-content-between w-100'>
								{/* <img src={selectedCompany.logo} alt='' /> */}
								<span className='company-name dropdown-text '>{selectedCompany.name}</span>
								{isCompanyOpen ? <ArrowUp /> : <ArrowDown />}
							</div>
						</DropdownToggle>
						<DropdownMenu id='company'>
							{companiesList?.map(
								(company, index) =>
									!company?.deactivated_at && (
										<DropdownItem
											as='button'
											className='dropdown-item company-name'
											key={company.id || index}
											onClick={() => {
												setSelectedCompany(company);
												if (window.location.pathname === '/dashboard') {
													console.log('here');
													setReload(true);
												} else {
													console.log('here2');
													setReload(true);
													navigate('/dashboard');
												}
											}}
										>
											{/* <img src={selectedCompany.logo} alt='' width={'50px'} height={'50px'} /> */}
											<span className='company-name'> {company.name} </span>
										</DropdownItem>
									)
							)}
						</DropdownMenu>
					</DropdownWrapper>
				)}

				{/* user  */}
				<DropdownWrapper className='company-dropdown '>
					<DropdownToggle id='user'>
						<div className='company-container d-flex flex-row justify-content-start w-100'>
							{/* <img src={userImage} alt='user-image' className='img-fluid me-1' /> */}
							<span className={'company-name dropdown-text'}>{activeUser.name}</span>
							{/* <i className='bi bi-chevron-down ms-2'></i> */}
							<i className='bi bi-three-dots-vertical'></i>
						</div>
					</DropdownToggle>
					<DropdownMenu id='user'>
						{checkPermission(permissionsList, 'profile-read') && (
							<DropdownItem to='/profile' as='a'>
								<div style={{ display: 'flex' }}>
									<i className='bi bi-person-fill me-2' style={{ marginInlineEnd: '.5rem' }}></i>
									{t('View Profile')}
								</div>
							</DropdownItem>
						)}

						<DropdownItem
							as='button'
							onClick={() => {
								dispatch(setLoading(true));
								logout()
									.unwrap()
									.then(res => {
										if (res.message) {
											dispatch(logoutReducer());
										}
									})
									.catch(err => {
										if (err.status === 403) {
											dispatch(logoutReducer());
										}
									});

								// removeState('cayesh_user_loggged');
								// window.location.reload();
							}}
						>
							<div style={{ display: 'flex' }}>
								<i className='bi bi-box-arrow-left me-2' style={{ marginInlineEnd: '.5rem' }}></i>
								{t('Logout')}
							</div>
						</DropdownItem>
					</DropdownMenu>
				</DropdownWrapper>

				{/* Notification */}
				<DropdownWrapper>
					{category === 'company' && (
						<DropdownToggle id='lng'>
							{/* {lang.key} */}
							<span className='text-uppercase'>{localStorage.getItem('i18nextLng')}</span>
							{/* <i className='bi bi-flag-fill'></i> */}

							{/* <i className='bi bi-chevron-down ms-1'></i> */}
						</DropdownToggle>
					)}
					<DropdownMenu id='lng'>
						{languages.map(
							(lang, index) =>
								lang !== selectedLang && (
									<DropdownItem
										key={index}
										onClick={() => {
											localStorage.setItem('i18nextLng', lang.key);
											setSelectedLang(lang);
											navigate(0);
										}}
										as='button'
									>
										{lang.name}
									</DropdownItem>
								)
						)}
					</DropdownMenu>
				</DropdownWrapper>

				<DropdownWrapper className='notification-dropdown'>
					<DropdownToggle id='notify' className='position-relative'>
						<i className='bi bi-bell-fill'></i>
						<i
							className='bi bi-dot'
							style={{
								color: 'orange',
								position: 'absolute',
								top: '-2px',
								right: '0',
								fontSize: '29px'
							}}
						></i>
					</DropdownToggle>
					<DropdownMenu id='notify'>
						{/* notification header */}
						<DropdownItem className='notify_dropdown-header' as='div'>
							<div className='notify_header'>
								<span className='notify-title'>Notifications</span>
								<Button className='notify-link' to='/notifications' linkStyle={true} as={'a'}>
									View All
								</Button>
							</div>
						</DropdownItem>
						{notifications?.map((item, key) => {
							return (
								<DropdownItem as='div' key={key} onClick={() => handleOnNotificationClick(item.notification_id)}>
									<NotifyItem className={'notify_item'} notificationMsg={item.message} notificationDate={item.data}>
										{/* {data.offerBtn ? (
                      <div className="mb-2 ms-4">
                        <Button className="btn-success me-3" type={'button'}>
                          Approve
                        </Button>
                        <Button className="btn-outline-danger" type={'button'}>
                          Delete
                        </Button>
                      </div>
                    ) : (
                      ''
                    )} */}
									</NotifyItem>
								</DropdownItem>
							);
						})}
					</DropdownMenu>
				</DropdownWrapper>
			</div>
		</header>
	);
};

Header.propTypes = {
	companies: PropTypes.array,
	permissions: PropTypes.array,
	user: PropTypes.object
};

const mapStateToProps = ({ auth: { companies, permissions, user } }) => ({
	companies,
	permissions,
	user
});

export default connect(mapStateToProps)(Header);
